import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { paths } from '../navigation/paths';

export function RequireAdmin({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('adminToken') : null;
  if (!token) {
    return <Navigate to={paths.login} replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}

export function RequirePlayer({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const playerId = typeof localStorage !== 'undefined' ? localStorage.getItem('playerId') : null;
  if (!playerId) {
    return <Navigate to={paths.play} replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
